import { useEffect, useState } from "react";

export const ELECTION_DAY_START = new Date("2026-11-03T00:00:00-05:00").getTime();
export const POLLS_CLOSE = new Date("2026-11-03T20:00:00-05:00").getTime();

const phaseAt = (now) => (now >= POLLS_CLOSE ? "results" : now >= ELECTION_DAY_START ? "election_day" : "countdown");

export const useElectionPhase = () => {
  const forced = new URLSearchParams(window.location.search).get("popup_phase");
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  return { phase: forced || phaseAt(now), now };
};

export const PopupCountdown = ({ now }) => {
  const diff = Math.max(0, ELECTION_DAY_START - now);
  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor((diff / 3600000) % 24)],
    ["Mins", Math.floor((diff / 60000) % 60)],
    ["Secs", Math.floor((diff / 1000) % 60)],
  ];
  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3" data-testid="popup-countdown">
      {units.map(([label, v]) => (
        <div key={label} className="rounded-xl bg-white/10 border border-white/20 py-2.5 sm:py-3 text-center">
          <div className="font-serif text-2xl sm:text-3xl font-extrabold text-white tabular-nums" data-testid={`popup-countdown-${label.toLowerCase()}`}>
            {String(v).padStart(2, "0")}
          </div>
          <div className="text-[10px] uppercase tracking-widest text-blue-200">{label}</div>
        </div>
      ))}
    </div>
  );
};

export const ElectionDayBanner = () => (
  <div className="rounded-2xl bg-donate text-white text-center py-4 px-3" data-testid="popup-election-day">
    <div className="font-serif text-3xl sm:text-4xl font-extrabold tracking-wide">ELECTION DAY</div>
    <div className="text-sm text-red-50 mt-1 font-semibold">Polls are open 7:00 AM – 8:00 PM ET</div>
  </div>
);
